import type { FormActions, FormColumn, FormField } from '@cli-types/core-engine/schema.js'
import { buildSortableHeaderDef } from '@next-adapter/generators/sortable-header/build-sortable-header-def.js'
import { getTableColumnSize } from '@next-adapter/generators/table-column-size/get-table-column-size.js'
import { renderAdminColumnsRenderer } from '@next-adapter/templates/renderers/generators/form-admin/admin-columns/generate-columns.js'
import { generateColumnDef } from './generate-column-def.js'

export function generateColumns(
  fields: FormField[],
  pascal: string,
  _kebab: string,
  _camel: string,
  actionImportPath: string,
  customColumns?: FormColumn[],
  actions?: FormActions
): string {
  const hasBadge = customColumns?.some((c) => c.type === 'badge') ?? false
  const hasDelete = actions?.delete !== false

  const columnDefs = customColumns
    ? customColumns.map((col) => generateColumnDef(col)).join(',\n')
    : fields
        .filter((f) => f.name)
        .map((f) => {
          const accessor = f.name!
          return renderAdminColumnsRenderer({
            kind: 'renderColumnsValueTemplate',
            props: {
              accessor: accessor,
              tableColumnSize: getTableColumnSize('default'),
              buildSortableHeaderDefBuildSortableHeaderDef: buildSortableHeaderDef(
                f.label ?? accessor
              ),
              fTextarea:
                f.type === 'textarea'
                  ? "{value ? String(value).substring(0, 100) + (String(value).length > 100 ? '...' : '') : '-'}"
                  : "{String(value ?? '-')}"
            }
          })
        })
        .join(',\n')

  const actionsImport = hasDelete ? `import { ${pascal}Actions } from './actions'\n` : ''
  const actionsColumn = hasDelete
    ? renderAdminColumnsRenderer({ kind: 'renderColumnsLayoutTemplate', props: { pascal: pascal } })
    : ''

  return renderAdminColumnsRenderer({
    kind: 'renderColumnsClientModuleTemplate',
    props: {
      pascal: pascal,
      actionImportPath: actionImportPath,
      actionsImport: actionsImport,
      hasBadgeBadge: hasBadge ? "import { Badge } from '@admin/components/ui/badge'\n" : '',
      columnDefsContent: columnDefs ? `${columnDefs}${actionsColumn ? ',' : ''}` : '',
      actionsColumnContent: actionsColumn ? `\n${actionsColumn}` : ''
    }
  })
}
